import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/ordenes-compra")({
  component: OrdenesCompraLayout,
});

export function OrdenesCompraLayout() {
  return <Outlet />;
}
